module.exports = __webpack_public_path__ + "static/media/OpenDyslexic-Bold-Italic.973e4f40.otf";